export default "__VITE_ASSET__DX1PW5t0__"